import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const getMeetupById = createAsyncThunk("getMeetupById", async (id, { rejectWithValue }) => {
  try {
    const response = await axiosHttp.get(`meetup/${id}`);
    return response.data;
  } catch (err) {
    if (!err.response) throw err;
    return rejectWithValue(err.response.data);
  }
});

const MeetupDetailsSlice = createSlice({
  name: "MeetupDetailsSlice",
  initialState: {
    isLoading: false,
    data: null,
    error: null,
  },
  reducers: {
    resetMeetupDetails: (state) => {
      state.isLoading = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMeetupById.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getMeetupById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data;
      })
      .addCase(getMeetupById.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { resetMeetupDetails } = MeetupDetailsSlice.actions;
export default MeetupDetailsSlice.reducer;
